import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import { useLocation } from "react-router-dom";

// Import components for each sub-tab
import ProfitAndLoss from "./ProfitAndLoss";
import BalanceSheet from "./BalanceSheet";

const FinancialReport = ({ filters, selectedBrand, selectedBrands = [] }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(() => {
    // Restore active tab from localStorage or URL
    const saved = localStorage.getItem("financial-reports-active-tab");
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");

    if (tabParam && ["profit-loss", "balance-sheet"].includes(tabParam)) {
      return tabParam;
    }
    return saved || "profit-loss";
  });

  // Read tab from URL query params
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");
    if (tabParam && ["profit-loss", "balance-sheet"].includes(tabParam)) {
      setActiveTab(tabParam);
      localStorage.setItem("financial-reports-active-tab", tabParam);
    }
  }, [location.search]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    localStorage.setItem("financial-reports-active-tab", key);
  };

  return (
    <Tabs
      activeKey={activeTab}
      onChange={handleTabChange}
      type="card"
      size="small"
    >
      <Tabs.TabPane tab="Profit & Loss Statement" key="profit-loss">
        <ProfitAndLoss />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Balance Sheet" key="balance-sheet">
        <BalanceSheet />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default FinancialReport;
